import eventBus from "@/events/eventBus";
import {CurrentUtils, QueryCommand} from "xmgoing-server";
import {addUserReplaceUrl, loadListByUrl} from "@/api/domainApi/domainComApi";
import {fixedOneNumber, fixedThreeNumber, fixedTwoNumber, fixedFourNumber, fixedNumber, StorageUtils} from "xmgoing-utils";
import {systemParamsMap} from "@/main-page/ctls/hooks/useDatasHooks";
import GoingUtils from "@/utils/goingUtils";
import {dbUtils, deepClone} from "xmgoing-utils";
import emitter from "@/events/eventBus";
import {useGridTableStore} from "@/store/modules/gridTableStore";
import {useAppStore} from "@/store/modules/app";
import {openUrl} from 'xmgoing-utils';
import {executeGetAsyncApi, executePostAsyncApi} from "@/api/login";
import {getDealEntryByBusId} from "@/api/sys/flowServer";
import {getUrlParams} from "xmgoing-utils";
import dayjs from "dayjs";
import {executeEngineEvent, executeUserFun, executeValidateForm} from "@/main-page/utils/FunctionEngineUtils";
import SysConfigUtils from "@/utils/sysConfigUtils";
import {noMoneyFormat} from "@/main-page-form/ctls/baseCtls/xmPrice/hooks/usePriceCtl";
import {savePrintHtml} from "@/main-page/jsParseEngine/pubServer";
import {nextTick, unref} from "vue";
import {cleanEmptyValues} from '@/main-page/utils/ctlUseComUtils';
import {resolveQueryFormFieldKeyFromState} from '@/main-page/utils/queryFormFieldUtils';
import {GoingNewUtils} from 'xmgoing-utils';
import {
  buildSubObjByGridKey,
  flushSubTableValidateStyle,
  getAllSubTableFlag,
  getSelectedMarkRecordIds,
} from '@/main-page/gridCellEditor/validate/subTableValidateUtils';

/**
 * 转义 CSS 选择器中的特殊字符（如 $ . : 等）
 */
const escapeSelector = (sel: string) => sel.replace(/[^a-zA-Z0-9_-]/g, '\\$&');

/**
 * 查找所有 class 为 xmForm 且父节点匹配指定选择器的元素 ID
 * @param parentSelector 父节点选择器
 * @returns 匹配元素的 ID 数组
 */
const findXmFormWithParent = (selKey: string) => {
  const backFormList:any=[];
  const xmFormElements = document.querySelectorAll('.xmForm');
  xmFormElements.forEach((formEl)=>{
    const parentObj=formEl.closest("#"+escapeSelector(selKey));
    if(parentObj){
      backFormList.push(formEl);
    }
  })
  return backFormList;
}
/**
 * 计算对象汇总信息
 * @param list
 */
export const getTotalValueList = function (list, sectionConfig?) {
  const totalObj = {};
  if (list && Array.isArray(list) && list.length > 0) {
    list.forEach((itemDb) => {
      Object.keys(itemDb).forEach((propName) => {
        //对金额处理
        if ((itemDb[propName] + '').indexOf(",")) {
          itemDb[propName] = noMoneyFormat(itemDb[propName])
        }
        if (!isNaN(parseFloat(itemDb[propName]))) {
          if (totalObj[propName] == null || totalObj[propName] === '') {
            totalObj[propName] = 0;
          }
          totalObj[propName] = parseFloat(itemDb[propName]) + parseFloat(totalObj[propName]);
        }
      })
    })
  }
  if (totalObj && Object.keys(totalObj).length > 0) {
    Object.keys(totalObj).forEach((propName) => {
      const val = totalObj[propName];
      let res = fixedNumber(val, 6);
      // if (sectionConfig && unref(sectionConfig)['numberShowType']) {
      //   const numberShowType = unref(sectionConfig)['numberShowType'];
      //   if (numberShowType === 'numberThree') {
      //     res = fixedThreeNumber(val);
      //   } else if (numberShowType === 'numberOne') {
      //     res = fixedOneNumber(val);
      //   } else if (numberShowType === 'numberFour') {
      //     res = fixedFourNumber(val);
      //   } else if (numberShowType === 'numberFive') {
      //     res = fixedNumber(val, 5);
      //   }
      // }
      totalObj[propName] = res;
    })
  }

  return totalObj;
}
export const codeMessage: any = {
  200: "服务器成功返回请求的数据。",
  201: "新建或修改数据成功。",
  202: "一个请求已经进入后台排队（异步任务）。",
  204: "删除数据成功。",
  400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
  401: "用户没有权限（令牌、用户名、密码错误）。",
  403: "用户得到授权，但是访问是被禁止的。",
  405: "请求的方法，post、get、put对应不对。",
  404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
  406: "请求的格式不可得。",
  410: "请求的资源被永久删除，且不会再得到的。",
  422: "当创建一个对象时，发生一个验证错误。",
  500: "服务错误，",
  502: "网关错误。",
  503: "服务不可用，服务器暂时过载或维护。",
  504: "网关超时。",
};

function getFileNam(fileName) {
  const fileNameAry = fileName.split("/");
  if (fileNameAry.length === 1) {
    fileName = fileNameAry[0];
  }
  if (fileNameAry.length > 1) {
    fileName = fileNameAry[fileNameAry.length - 1];
  }
  return fileName;
}

/**
 * 是否为树选中 id 写入的值：选中 id 数组，或由选中 id 拼接的字符串
 */
function isTreeCheckParamValue(value, checkedIds) {
  if (!checkedIds.length) {
    return false;
  }
  const ids = checkedIds.map((id) => String(id));
  if (Array.isArray(value)) {
    return value.length === ids.length && value.every((item, index) => String(item) === ids[index]);
  }
  if (typeof value !== 'string' || !value.startsWith(ids[0]) || !value.endsWith(ids[ids.length - 1])) {
    return false;
  }
  if (ids.length === 1) {
    return value === ids[0];
  }
  const joinChar = value.slice(ids[0].length, value.indexOf(ids[1], ids[0].length));
  return value === ids.join(joinChar);
}

/**
 * 显示错误信息
 */
let errorTimer: any = null
const showErrorMessage = function (code: string | number, msg: string) {
  if (errorTimer) {
    clearTimeout(errorTimer)
  }
  errorTimer = setTimeout(() => {
    (window as any).GoingUtils.showErrorMessage(codeMessage[code] + ":" + msg);
  }, 300)
}


interface IExecuteConfig {
  url: string,
  isFileStream:boolean;
  method: string,
  fileName?:string,
  params: any,
  nodeProp?:any;
  backFun: any,
  errorFun: any,
  showLoading?: boolean,
  showErrorFlag?: boolean,
}

const constantObj = {
  emptyOrNull: '',
  objectNull: null,
  emptyArray: [],
  'not empty': 'not empty'
}

/**
 * js引擎解析 视图模型
 */
export class ViewModel {
  //vue上下文
  viewPage;
  //界面缓存
  pageModelsStore;
  //数据源缓存
  dataSourceStore;
  //打开部件界面
  openSubComPage;
  //打开界面路由跳转
  openRouter;
  //系统变量
  systemParams;
  //参数变量
  vuexParams;
  //授权信息
  aclField;
  //事件总线
  emitter;
  nodeParams;
  treeCheckParamKeys;
  constant;

  constructor({viewPage, pageModelsStore, dataSourceStore}: any) {
    window.openUrl=openUrl;
    if (pageModelsStore) {
      this.pageModelsStore = pageModelsStore;
    }
    if (dataSourceStore) {
      this.dataSourceStore = dataSourceStore;
    }
    if (viewPage) {
      this.viewPage = viewPage;
    }
    this.emitter = emitter;
    this.constant = constantObj;
    this.nodeParams = {};
    this.systemParams = systemParamsMap;
    this.vuexParams = pageModelsStore?.state;
    nextTick(() => {
      this.initAclField();
    })
    return this
  }

  /**
   * 获取路由参数
   * @param paramsName
   */
  getRouterParams(paramsName) {
    let route = useRoute()
    let {query, params} = toRefs(route);
    if (params.value[paramsName] != null && params.value[paramsName] !== '') {
      return params.value[paramsName];
    }
    if (query.value[paramsName]) {
      return query.value[paramsName];
    }
  }

  /**
   * 获取当前编辑行集合
   * @param selKey
   * @param recordType
   */
  getEditorRecordList(selKey,recordType){
    const targetObj={editorRecordList:[]};
    eventBus.emit('getEditorRecordList_' + GoingUtils.getEventCtlKey(selKey), {recordType,targetObj});
    return targetObj.editorRecordList;
  }

  /**
   * 缓存设置
   */
  setSessionCache(paramsName, paramsValue) {
    StorageUtils.addSessionItem(paramsName, paramsValue);
  }

  /**
   * 表单打印
   * @param subPageKey
   */
  printPageSub(subPageKey){
    const pageCode=GoingUtils.getPageCode();
    if(GoingUtils.isDesFlag()){
      GoingUtils.showWarningMsg("请到预览状态、运行态进行验证")
      return
    }

    const subPageKeyEl=document.querySelector("#"+subPageKey);
    if(subPageKeyEl){
      let curRecord='';
      const formObj:any=subPageKeyEl.querySelector(".xmFormBody");
      if(formObj){
        curRecord=this.pageModelsStore.state[formObj.getAttribute("id")];
      }
      savePrintHtml({partCode:subPageKey,printContent:subPageKeyEl.innerHTML,pageCode:pageCode,curRecord},()=>{
        const params={pageCode,subPageKey};
        params["sessionId"] = StorageUtils.getSessionItem("sessionId");
        let url=openUrl(SysConfigUtils.printDesUrl + `/xm-print-des/#/printFormPage`,params);
        url=url.replace("//xm-print-des","/xm-print-des");
        url=url.replace("/undefined/","/");
        url=url.replace("//#","");
        window.open(url)
      });
    }
  }
  /**
   * 执行函数
   * @param funName
   * @param ctlKey
   */
  executeFun(funType, gridKey, funTypeStr = 'systemFun') {
    if ((funTypeStr + '').indexOf("UserFun") >= 0) {
      executeUserFun(funType, gridKey);
      return
    }
    if (funType === 'clearGridSelList') {
      const gridTableStore: any = useGridTableStore();
      gridTableStore.clearGridSels(gridKey);
    }
    return executeEngineEvent(gridKey, funType);
  }

  /**
   * 对象属性的转换
   * @param list
   * @param transList
   */
  getObjToNewObjStr(list, transList) {
    if (list && Array.isArray(list)) {
      list.forEach((record) => {
        if (transList && Array.isArray(transList)) {
          transList.forEach(({orginField, targetField}) => {
            record[targetField] = deepClone(record[orginField]) || '';
          })
        }
      })
    }
    return list;
  }

  setGridList(selKey,list,appendType){
    eventBus.emit(GoingUtils.getEventCtlKey(selKey) + '_setGridList', {list,appendType});
  }

  updateGridRow(selKey, rowData, recordId) {
    const eventKey = GoingUtils.getEventCtlKey(selKey) + '_updateGridRow';
    const isEmptyRecordId = (id) => {
      if (id == null || id === '') {
        return true;
      }
      if (typeof id === 'object') {
        const val = id.id ?? id.key ?? id.recordId;
        return val == null || val === '';
      }
      return false;
    };
    if (isEmptyRecordId(recordId)) {
      let dataList = unref(rowData);
      if (typeof dataList === 'string') {
        try {
          dataList = JSON.parse(dataList);
        } catch {
          GoingUtils.showWarningMsg('批量更新时数据来源需为数组，且原数据id需为空');
          return;
        }
      }
      if (!Array.isArray(dataList) || dataList.length === 0) {
        GoingUtils.showWarningMsg('批量更新时数据来源需为数组，且原数据id需为空');
        return;
      }
      dataList.forEach((item) => {
        if (item == null || typeof item !== 'object') {
          return;
        }
        const itemId = item.id ?? item.key ?? item.recordId;
        if (itemId == null || itemId === '') {
          return;
        }
        eventBus.emit(eventKey, {rowData: item, recordId: itemId});
      });
      return;
    }
    eventBus.emit(eventKey, {rowData, recordId});
  }

  /**
   * 设置列操作权限
   * @param selKey
   * @param fieldList
   * @param permission 可选值: 'readonly'(只读), 'disabled'(禁用), 'editable'(编辑)
   *                   兼容旧配置: boolean类型，true为禁用，false为编辑
   */
  setColDisabled(selKey, fieldList, permission = 'disabled') {
    // 先存储到 store 中，供子表格创建时使用
    const gridTableStore = useGridTableStore();
    gridTableStore.setColPermission(selKey, fieldList, permission);

    // 兼容旧的事件总线方式
    if (typeof fieldList === 'string') {
      fieldList = fieldList.split(";");
    }
    if (typeof fieldList === 'string') {
      fieldList = fieldList.split(",");
    }
    const eventKey = GoingUtils.getEventCtlKey(selKey) + "_setColDisabled";
    eventBus.emit(eventKey, {fieldList, permission});
  }

  /**
   * 设置列显示 隐藏
   * @param selKey
   * @param fieldList
   * @param disFlag
   */
  setColHideOrShow(selKey,fieldList,disFlag=true){
    // 先存储到 store 中，供子表格创建时使用
    const gridTableStore = useGridTableStore();
    gridTableStore.setColShow(selKey, fieldList, disFlag === true);

    // 兼容旧的事件总线方式
    if (typeof fieldList === 'string') {
      fieldList = fieldList.split(";");
    }
    if (typeof fieldList === 'string') {
      fieldList = fieldList.split(",");
    }
    const eventKey = GoingUtils.getEventCtlKey(selKey) + "_setColHideOrShow";
    eventBus.emit(eventKey, {fieldList, disFlag});
  }

  /**
   * 批量异常处理
   */
  dealMoreRecordResults(res) {
    const results: any = deepClone(res);
    const backResult: any = {errorCount: 0, okCount: 0, errorMsg: [], title: ''};
    if (results && Array.isArray(results)) {
      const errorList = results.filter((itemDb) => {
        return itemDb.success === false;
      })
      errorList.forEach((itemDb) => {
        backResult.errorMsg.push(`${itemDb.code || ''} ：${itemDb.errorMsg}`)
      })
      backResult.errorCount = errorList.length || 0;
      const okList = results.filter((itemDb) => {
        return itemDb.success === true;
      });
      backResult.okCount = okList.length || 0;
      backResult.title = `共${res.length}条单据，提交成功${backResult.okCount}条，失败${backResult.errorCount}条`
    }
    return backResult;
  }

  /**
   * 显示多错误信息
   * @param res
   */
  showMoreErrorResults(res) {
    GoingUtils.showMoreErrorResults(res);
  }


  /**
   * 获取部件界面表单的id
   * @param selKey
   */
  getPageFormObjId(selKey) {
    // 对选择器中的特殊字符进行转义
    const escapeSelector = (id) => {
      if (!id) return id;
      return id.replace(/([^\w-])/g, '\\$1');
    };
    const pageContentEl = document.querySelector("#" + escapeSelector(GoingUtils.getPageCode()+"_"+selKey))||document.querySelector("#" + escapeSelector(selKey));
    if (pageContentEl) {
      const xmFormEl = pageContentEl?.querySelector(".xmFormBody");
      if (xmFormEl) {
        const formId = xmFormEl.getAttribute("id");
        console.error(formId, "-------formId")
        if (formId) {
          return formId;
        } else {
          GoingUtils.showErrorMessage('部件表单对象不存在，请确认！');
        }
      }
    }
    //为了防止有些电脑获取不到，所以通过form去找
    const formElList = findXmFormWithParent(selKey);
    if (formElList && formElList.length > 0) {
      return formElList[0]?.getAttribute("id");
    }
    //为了防止还不对 才有不严谨方式获取
    let formId ='';
    this.pageModelsStore.stateRemarks.forEach((itemRemark)=>{
      if(itemRemark.ctlType==='xmForm'){
        formId = itemRemark.value;
      }
    })
    return formId;
  }

  /**
   * 获取部件界面的表单对信息
   * @param selKey
   */
  getPageFormObj(selKey) {
    const pageContentEl = document.querySelector("#" + escapeSelector(GoingUtils.getPageCode()+"_"+selKey))||document.querySelector("#" + escapeSelector(selKey));
    let backObj={};
    console.error(pageContentEl,"-------getPageFormObj")
    if (pageContentEl) {
      const xmFormEl = pageContentEl?.querySelector(".xmFormBody");
      console.error(xmFormEl,"-------xmFormEl")
      if (xmFormEl) {
        const formId = xmFormEl.getAttribute("id");
        console.error(formId,"-------formId")
        if (formId) {
          backObj = this.getFormVuexVal(formId);
        } else {
          GoingUtils.showErrorMessage('部件表单对象不存在，请确认！');
        }
      }
    }
    //为了防止有些电脑获取不到，所以通过form去找
    if(backObj==null){
      console.error(backObj,"-------表示全局变量里面获取表单对象为空");
      const formElList=findXmFormWithParent(selKey);
      if(formElList&&formElList.length>0){
        return  this.getFormVuexVal(formElList[0]?.getAttribute("id"));
      }
    }

    //为了防止还不对 才有不严谨方式获取
    if (backObj == null) {
      console.error(backObj,"-------前面都不对");
      console.error(this.pageModelsStore,"-------前面都不对");
      console.error(this.pageModelsStore.state,"-------state");
      console.error(this.pageModelsStore.stateRemarks,"-------stateRemarks");
      this.pageModelsStore.stateRemarks.forEach((itemRemark)=>{
        if(itemRemark.ctlType==='xmForm'){
          backObj = this.pageModelsStore.state[itemRemark.value];
        }
      })
    }
    console.error(backObj,"-------backObj")
    return backObj;
  }
  /**
   * 设置本行数据组件下拉集
   */
  setRecordDataCtlOps(colFieldId,recordId,options){
    eventBus.emit(recordId+'_setDataCtlOpts_'+colFieldId, {options});
  }

  /**
   * 设置部件编码
   * @param pageCode
   */
  setXmPageContentCode(pageCode, selKey,selKeyNew) {
    if(selKeyNew){
      eventBus.emit('setXmPageContentCode' + selKeyNew, {pageCode,moduleCodeVal:selKey});
    }else{
      eventBus.emit('setXmPageContentCode' + selKey, {pageCode});
    }
  }

  /**
   * 查询部件信息进行展示
   * @param domainCode
   * @param recordId
   */
  getDoaminJsonToPageContent(domainCode,recordId,fieldName){
    eventBus.emit('getDoaminJsonToPageContent', {domainCode,recordId,fieldName});
  }

  flushFormElData(formKey,formFieldId){
    nextTick(()=>{
      eventBus.emit(formKey+"_"+formFieldId+"_flushFormElData");
    })
  }
  /**
   * 表单值刷新
   * @param paramsName
   * @param paramsValue
   */
  formFlush(selKey) {
    eventBus.emit(GoingUtils.getEventCtlKey(selKey) + '_FlushFromObj', {});
  }

  /**
   * 设置表单值
   */
  setFormValue(formKey, fieldId, fieldValue) {
    if(fieldValue==='systemParams.currentDate'){
      fieldValue=dayjs().format("YYYY-MM-DD");
    }
    if(fieldValue==='systemAclField.userName'){
      CurrentUtils._loadUser(false, (userJson) => {
        fieldValue = userJson["name"];
      })
    }
    if(fieldValue==='systemAclField.userId'){
      CurrentUtils._loadUser(false, (userJson) => {
        fieldValue = userJson["id"];
      })
    }
    const {state} = this.pageModelsStore;
    if (state[formKey] != null) {
      state[formKey][fieldId] = fieldValue;
    } else {
      state[formKey] = {};
      state[formKey][fieldId] = fieldValue;
    }
  }

  /**
   * 设置查询表单字段值（支持字段名不带 _in 等后缀的自动匹配）
   */
  setQueryFormValue(queryFormKey, fieldId, fieldValue, autoQuery = false) {
    if (fieldValue === 'systemParams.currentDate') {
      fieldValue = dayjs().format("YYYY-MM-DD");
    }
    if (fieldValue === 'systemAclField.userName') {
      CurrentUtils._loadUser(false, (userJson) => {
        fieldValue = userJson["name"];
      })
    }
    if (fieldValue === 'systemAclField.userId') {
      CurrentUtils._loadUser(false, (userJson) => {
        fieldValue = userJson["id"];
      })
    }
    eventBus.emit(queryFormKey + '_setQueryFormField', {fieldId, fieldValue});
    const {state} = this.pageModelsStore;
    const formState = state[queryFormKey] || {};
    const resolvedKey = resolveQueryFormFieldKeyFromState(fieldId, formState);
    if (state[queryFormKey] != null) {
      state[queryFormKey][resolvedKey] = fieldValue;
    } else {
      state[queryFormKey] = {};
      state[queryFormKey][resolvedKey] = fieldValue;
    }
    if (autoQuery === true) {
      nextTick(() => {
        eventBus.emit(queryFormKey + '_triggerQueryForm', {});
      });
    }
  }

  /**
   * 设置树组件选中值
   * @param ids
   * @param strFlag
   * @param joinChar
   */
  setTreeCheckIds(treeCtlKey, ids, strFlag, joinChar) {
    eventBus.emit(GoingUtils.getEventCtlKey(treeCtlKey) + '_setTreeCheckIds', {ids, strFlag, joinChar});
  }

  /**
   * 设置表格组件选中值
   * @param ids
   * @param strFlag
   * @param joinChar
   */
  setGridSelRecordIds(treeCtlKey, ids, strFlag, joinChar) {
    eventBus.emit(GoingUtils.getEventCtlKey(treeCtlKey) + '_setGridSelIds', {ids, strFlag, joinChar});
  }

  /**
   * 获取树选中值
   * @param treeCtlKey
   * @param ids
   * @param strFlag
   * @param joinChar
   */
  getTreeCheckIds(treeCtlKey, backFun) {
    if (typeof backFun !== 'function') {
      eventBus.emit(GoingUtils.getEventCtlKey(treeCtlKey) + '_getTreeCheckIds', {backFun});
      return;
    }
    let responded = false;
    let treeRes;
    eventBus.emit(GoingUtils.getEventCtlKey(treeCtlKey) + '_getTreeCheckIds', {
      backFun: (res) => {
        responded = true;
        treeRes = res;
      }
    });
    // 树控件未挂载时不执行回调，和原来一致
    if (!responded) {
      return;
    }
    const checked = treeRes && treeRes.checked;
    const checkedIds = Array.isArray(checked) ? checked : (checked && Array.isArray(checked.checked) ? checked.checked : []);
    if (!this.nodeParams) {
      this.nodeParams = {};
    }
    const nodeParams = this.nodeParams;
    if (!this.treeCheckParamKeys) {
      this.treeCheckParamKeys = {};
    }
    if (!this.treeCheckParamKeys[treeCtlKey]) {
      this.treeCheckParamKeys[treeCtlKey] = new Set();
    }
    const paramKeys = this.treeCheckParamKeys[treeCtlKey];
    const before = {...nodeParams};
    const result = backFun(treeRes);
    Object.keys(nodeParams).forEach((paramKey) => {
      const value = nodeParams[paramKey];
      const written = value !== before[paramKey] || value === checked || value === checkedIds;
      if (written && isTreeCheckParamValue(value, checkedIds)) {
        paramKeys.add(paramKey);
      }
    });
    // 旧脚本只在选中列表不为空时才写 nodeParams，取消全选后会沿用上一次的 id
    if (!checkedIds.length) {
      paramKeys.forEach((paramKey) => {
        const value = nodeParams[paramKey];
        if (value === before[paramKey] && (Array.isArray(value) || typeof value === 'string')) {
          nodeParams[paramKey] = typeof value === 'string' ? '' : [];
        }
      });
    }
    return result;
  }

  /**
   * 校验列信息
   * @param treeCtlKey
   * @param backFun
   */
  valiRecordColVal(gridKey, selColId, valiValue, backFun, valiType = 'allEqual') {
    const gridTableStore: any = useGridTableStore();
    const selRecords = gridTableStore.getRecordObjs(gridKey);
    let backFlag = true;
    if (valiType === 'exist') {
      // 存在
      backFlag = selRecords.some(item => item[selColId] === valiValue);
    } else if (valiType === 'allEmpty') {
      // 全为空
      backFlag = selRecords.every(item => (!item[selColId] || item[selColId] === ''));
    } else if (valiType === 'notEmpty') {
      // 全不为空
      backFlag = selRecords.every(item => (item[selColId] && item[selColId]?.length > 0));
    } else {
      if (selRecords && Array.isArray(selRecords) && selRecords.length > 0) {
        selRecords.forEach((recordDb) => {
          if (valiType === 'notEqual') {
            // 全不等
            if ((recordDb[selColId] + '') === valiValue) {
              // 只要有一个等 就返回false
              backFlag = false;
            }
          } else if (valiType === 'allEqual') {
            // 全等
            if ((recordDb[selColId] + '') !== valiValue) {
              // 只要有一个不等 就返回false
              backFlag = false;
            }
          }
        })
      }
    }
    backFun && backFun(backFlag);
  }

  /**
   * 获取session缓存信息
   * @param val
   */
  getSessionValues(val) {
    return StorageUtils.getSessionItem(val);
  }

  getUrlParams(val) {
    return getUrlParams(val, true);
  }

  getNumber(val) {
    return parseFloat(val);
  }

  getRecordCellValue(gridKey, ids, fieldId, returnType = 'string') {
    const targetObj = {cellValues: ''};
    eventBus.emit(GoingUtils.getEventCtlKey(gridKey) + '_getRecordCellValue', {targetObj, ids, fieldId, returnType});
    return targetObj.cellValues;
  }


  onCloseCuWin() {
    eventBus.emit('closeOpenDrawer');
    eventBus.emit('onClosCurWin');
  }

  flushPageByCode(pageCode,pageName){
    const curPageCode=GoingUtils.getPageCode();
    StorageUtils.addItem(pageCode+"_name",(pageName||''));
    eventBus.emit('menuClick',`/xm-erp/commonPage/${pageCode}`);
    addUserReplaceUrl({path:`/xm-erp/commonPage/${curPageCode}`,targetPath:`/xm-erp/commonPage/${pageCode}`,targetName:pageName});
    // const pageCodeReal=StorageUtils.getItem(pageCode);
    // if(pageCodeReal!==pageCode){
    //   alert(pageName)
    //   StorageUtils.addItem(GoingUtils.getPageCode(),pageCode);
    //   StorageUtils.addItem(GoingUtils.getPageCode()+"_name",pageName);
    //
    //   return;
    // }
  }

  /**
   * 通知消息给到用户组件
   * @param userCtlName
   * @param params
   */
  postMsgToUserCtl(userCtlName, params, eventName) {
    eventBus.emit(userCtlName + '_userEvent', {params, eventName});
  }


  /**
   * 显示警告信息
   */
  showWarningMsg(msg) {
    GoingUtils.showWarningMsg(msg)
  }

  /**
   * 显示选人组件
   * @param val
   */
  async showUserSelCtl({confirmFun, cancelFun}) {
    return eventBus.emit('openUserSelCtl', {confirmFun, cancelFun});
  }

  /**
   * 获取选中的记录信息
   * @param gridKey
   */
  getSelIdsList(gridKey){
    return eventBus.emit(GoingUtils.getEventCtlKey(gridKey) + '_getSelIdsList',{});
  }

  /**
   * 打印相应记录信息
   * @param url
   * @param method
   * @param recordId
   */
  recordPrint(url, method = 'POST', params,getUrl=false) {
    params["sessionId"] = StorageUtils.getSessionItem("sessionId");
    params["url"] = url;
    params["projectI18n"] = StorageUtils.getItem('projectI18n');
    url=openUrl(SysConfigUtils.printDesUrl + `/xm-print-des/#/printByPdf`,params);
    url=url.replace("//xm-print-des","/xm-print-des");
    url=url.replace("/undefined/","/");
    url=url.replace("//#","");
    if(getUrl){
      return url;
    }
    window.open(openUrl(url, params));
  }

  /**
   * 多模板打印
   * @param printUrl 打印接口地址
   * @param method 请求方法
   * @param params 参数对象，包含 templateCode、recordId、fileName
   */
  async multiTemplatePrint(printUrl: string, method: string = 'POST', params: { templateCode?: string; recordId?: string; fileName?: string; [key: string]: any } = {}) {
    try {
      // 从参数中提取必要信息
      const { templateCode, recordId, fileName } = params;

      // 参数验证
      if (!templateCode) {
        this.showErrorMsg('打印模板编码(templateCode)不能为空，请检查参数配置！');
        return;
      }
      if (!recordId) {
        this.showErrorMsg('当前行记录ID(recordId)不能为空，请检查参数配置！');
        return;
      }
      if (!fileName) {
        this.showErrorMsg('打印文件名(fileName)不能为空，请检查参数配置！');
        return;
      }

      // 查询模板信息 - 使用 loadListByUrl 方式
      const response = await loadListByUrl({
        url: '/api/go-lcc/lccPrintTemplate/listByCode',
        method: 'GET',
        queryParams: { code: templateCode },
        pageSize: 100,
        current: 1
      });

      if (!response || !response.records || response.records.length === 0) {
        this.showWarningMsg('还未设计打印模版，请联系管理员！');
        return;
      }

      const templates = response.records;

      // 如果只有一个模板，直接调用 recordPrint
      if (templates.length === 1) {
        const printParams = {
          recordId: recordId,
          templateId: templates[0].id,
          fileName: fileName
        };
        this.recordPrint(printUrl, method, printParams);
        return;
      }

      // 如果有多个模板，弹出多模板选择窗口
      if (templates.length > 1) {
        this.openMultiTemplatePrintWin(templates, {
          printUrl,
          method,
          recordId,
          fileName
        });
      }

    } catch (error: any) {
      console.error('多模板打印出错：', error);
      this.showErrorMsg('多模板打印失败：' + (error.message || '未知错误'));
    }
  }

  /**
   * 打开多模板打印选择窗口
   * @param templates 模板列表
   * @param printConfig 打印配置
   */
  openMultiTemplatePrintWin(templates: any[], printConfig: { printUrl: string; method: string; recordId: string; fileName: string }) {
    const { printUrl, method, recordId, fileName } = printConfig;

    // 使用 eventBus 触发打开多模板选择窗口的事件
    emitter.emit('openMultiTemplatePrintDrawer', {
      templates: templates,
      printUrl: printUrl,
      method: method,
      recordId: recordId,
      fileName: fileName,
      onSelectTemplate: (templateId: string) => {
        const printParams = {
          recordId: recordId,
          templateId: templateId,
          fileName: fileName
        };
        this.recordPrint(printUrl, method, printParams);
      }
    });
  }

  /**
   * 显示错误消息
   * @param msg 错误消息
   */
  showErrorMsg(msg: string) {
    // 尝试使用多种方式显示消息
    try {
      // 使用 Modal
      if (window !== undefined && (window as any).$message) {
        (window as any).$message.error(msg);
      } else if (window !== undefined && (window as any).$Modal) {
        (window as any).$Modal.error({
          title: '错误',
          content: msg
        });
      } else {
        console.error(msg);
        // 最后尝试使用 alert
        alert('错误：' + msg);
      }
    } catch (e) {
      console.error(msg);
      alert('错误：' + msg);
    }
  }

  /**
   * 附件下载操作
   * @param downUrl
   * @param fileName
   * @param params
   */
  downFileFun({downUrl, fileName, params = {}}) {
    downUrl = downUrl.replace('/https', "https");
    downUrl = downUrl.replace('/http', "http");
    //如果下载url 包含了 http或者https
    if (downUrl.indexOf("https") >= 0 || downUrl.indexOf("http") >= 0) {
      const urlAry = downUrl.split("/");
      if (urlAry && urlAry.length > 0) {
        fileName = urlAry[urlAry.length - 1];
      }
    }
    fileName = getFileNam(fileName);
    const queryCommand = new QueryCommand({showTip: false});
    return queryCommand.executeExport(
      downUrl,
      (fileName || '导入模版'),
      {...params}
    );
  }

  /**
   * 属性融合
   */
  mergeProp(pObj, sonObj) {
    if (typeof (sonObj) === "object") {
      pObj = {...pObj, ...sonObj};
    }
    return pObj;
  }

  mergeNodeProp(nodeProp) {
    if (nodeProp) {
      Object.keys(nodeProp).forEach((propName) => {
        this[propName] = nodeProp[propName];
      })
    }
  }

  setPageName(pagName) {
    const appStore = useAppStore();
    appStore.setPageName(pagName);
  }

  /**
   * 新增编辑行
   * @param gridKey
   */
  addEditorRow(gridKey, defRowRecord = {},insertPosition) {
    if (!defRowRecord['id'] || defRowRecord['id'] === '') {
      // 新增的数据没有id 则生成一个
      defRowRecord['id'] = GoingNewUtils.getUUid(12);
    }
    eventBus.emit(GoingUtils.getEventCtlKey(gridKey) + '_addEditorRow', {...defRowRecord,insertPosition});
  }


  /**
   * 关闭部件界面
   */
  closeSubPageWin() {
    try {
      eventBus.emit('closeOpenDrawer', {});
    } catch (e) {
      console.error(e, "=====closeOpenDrawer====");
    }
    try {
      eventBus.emit('onClosCurWin', {});
    } catch (e) {
      console.error(e, "======onClosCurWin===");
    }
  }


  /**
   * 取消行编辑
   * @param gridKey
   */
  cancelEditorRow(gridKey, recordId) {
    eventBus.emit(gridKey + '_cancelEditorRow', {recordId});
  }

  /**
   * 获取表格对象
   * @param gridKey
   */
  getGridRefObj(gridKey) {
    const gridTableStore: any = useGridTableStore();
    return gridTableStore.getGridRefObjByKey(gridKey)
  }


  /**
   * 编辑表格记录
   * @param gridKey
   * @param recordId
   */
  editorRowRecord(gridKey, recordId) {
    eventBus.emit(gridKey + '_editorRowRecord', {recordId});
  }

  async setNotNewUser() {
    const queryCommand = new QueryCommand({
      showTip: false,
      url: `/api/pe-portal/users/setNotNewUser`,
    });
    queryCommand.executeQueryPromise({})
  }

  /**
   * 复制当前记录信息
   * @param gridKey
   * @param recordId
   */
  copyCurrentRecord(gridKey, record) {
    return eventBus.emit(GoingUtils.getEventCtlKey(gridKey) + '_copyCurrentRecord', {record});
  }

  //删除表格记录
  getGridRemoveRecord(gridKey, recordId) {
    return  eventBus.emit(GoingUtils.getEventCtlKey(gridKey) + '_gridRemoveRecord', {recordId});
  }



  //获取子表id集合
  getSubGridSelIds(gridKey) {
    const targetObj={list:[]};
    eventBus.emit(GoingUtils.getEventCtlKey(gridKey) + '_getSubGridSelIds', {targetObj});
    return targetObj.list;
  }

  /**
   * 获取子表记录集合
   * @param gridKey
   */
  getSubGridSelRecords(gridKey) {
    const targetObj={list:[]};
    return eventBus.emit(GoingUtils.getEventCtlKey(gridKey) + '_getSubGridSelRecords', {targetObj});
    return targetObj.list;
  }

  //获取主表记录id集合
  getMainGridSelIds(gridKey) {
    const targetObj={list:[]};
    return eventBus.emit(GoingUtils.getEventCtlKey(gridKey) + '_getMainGridSelIds', {targetObj});
    return targetObj.list;
  }
  /**
   * 查询表格模式设置
   * @param gridKey
   * @param params
   */
  gridQueryScope(gridKey, params) {
    eventBus.emit(GoingUtils.getEventCtlKey(gridKey) + '_gridQueryScope', {...params});
    nextTick(() => {
      eventBus.emit(GoingUtils.getEventCtlKey(gridKey) + '_changeGridCols', {...params});
    })
  }

  initAclField() {
    setTimeout(() => {
      if (dbUtils.getCachUser()) {
        this.aclField = {...dbUtils.getCachUser()};
      }
    }, 1000)
  }

  total(list) {
    return getTotalValueList(list);
  }

  //设置控件属性
  setCtlProp(ctlKey, propName, propValue, inParams) {
    //如果设置宽高
    if (propName === 'height' || propName === "width") {
      if (unref(inParams.borderConfig)) {
        if ((propValue + '').indexOf('%') >= 0 && isNaN(parseFloat(propValue))) {
          unref(inParams.borderConfig)[propName] = parseFloat(propValue);
        } else {
          unref(inParams.borderConfig)[propName] = parseFloat(propValue) + 'px';
        }
      }
    }
  }


  //请求操作
  async query({url, methods, params, async, outParamsCode}) {
    const viewModelObj = this;
    params = {...params};
    if (async) {
      url = url.replace('/api', "");
      const resList = await loadListByUrl({url, queryParams: params, method: methods, pageSize: 9999, current: 1});
      viewModelObj.nodeParams[outParamsCode] = resList;
    } else {
      const queryCommnad = new QueryCommand({url: url, method: methods});
      queryCommnad.executeQueryPromise({params}).then((res) => {
        viewModelObj.nodeParams[outParamsCode] = res;
      }, (error) => {

      });
    }
  }


  initViewPage(viewPage) {
    if (viewPage == null) {
      return;
    }
    this.viewPage = viewPage;
  }

  /**
   * 打开窗口
   * @param url
   * @param winTitle
   * @param winWidth
   * @param winHeight
   */
  openWindow({url, winTitle, winWidth, winHeight}) {
    if (winWidth.indexOf("%") >= 0) {
      winWidth = document.body.clientWidth * parseInt(winWidth) / 100;
    }
    if (winHeight.indexOf("%") >= 0) {
      winHeight = document.body.clientHeight * parseInt(winHeight) / 100;
    }
    if (url) {
      const params = {};
      params['sessionId'] = StorageUtils.getSessionItem("sessionId");
      url = openUrl(url, params);
    }
    eventBus.emit('onOpenWin', {url, wTitle: winTitle, wWidth: winWidth, wHeight: winHeight});
  }

  /**
   * 获取参数值
   * @param statePropName
   */
  getVuexParams(statePropName) {
    if ((statePropName + '').indexOf(".") > 0) {
      const propAry = (statePropName + '').split(".");
      if (propAry.length > 1) {
        return this.vuexParams[propAry[0]][propAry[1]];
      }
    } else {
      return this.vuexParams[statePropName];
    }
  }

  setVuexParams(statePropName, value) {
    this.vuexParams[statePropName] = value;
  }


  //初始化打开的路径
  initUrlParams(url, params) {
    url = url.replace(/\/\//g, "/");
    url = url.replace(/http:\//g, "http://");
    url = url.replace("${xm-auto-flow}", SysConfigUtils.autoFlowUrl);
    url = url.replace("${SysConfigUtils.xmPrintPage}", SysConfigUtils.xmPrintPage+'/xm-print-des');
    url = url.replace("xm-auto-flow//", 'xm-auto-flow/');
    if(params&&typeof params !== "object") {
      params['system'] = true;
      params.projectI18n=StorageUtils.getItem("projectI18n") || "zh-CN";
      sessionId: StorageUtils.getSessionItem("sessionId");
    }
    const appendStr: Array<string> = [];
    if (params && Object.keys(params).length > 0) {
      Object.keys(params).forEach((propName) => {
        appendStr.push(`${propName}=${params[propName]}`);
      })
      return url + "?" + appendStr.join("&");
    } else {
      return url;
    }
  }

  //打开新界面
  openWindowUrl(url) {
    if (GoingUtils.isDesFlag()) {
      console.log(url, "--openWindowUrl-成功-")
      return;
    }
    if (url) {
      const params = {};
      params['sessionId'] = StorageUtils.getSessionItem("sessionId");
      url = openUrl(url, params);
    }
    window.open(url)
  }

  //本界面打开
  hrefUrl(url) {
    if (GoingUtils.isDesFlag()) {
      console.log(url, "--hrefUrl-成功-")
      return;
    }
    window.location.href = url
  }

  nextTickFun(backFun) {
    nextTick(() => {
      backFun && backFun();
    })
  }


  //路由界面
  routerPath(url, queryDef, exportUrl, pageTitle, routeParamsDef = {}) {
    if (GoingUtils.isDesFlag()) {
      console.log(url, "--routerPath-成功-")
      return;
    }
    const queryParams = queryDef || {};
    const routeParams = (routeParamsDef && typeof routeParamsDef === 'object') ? routeParamsDef : {};
    if (pageTitle) {
      StorageUtils.addSessionItem('curMenuNameByMsg', pageTitle)
      StorageUtils.addSessionItem('curMenuName', pageTitle)
    }
    const routerPushOptions = {path: url, query: queryParams, params: routeParams};
    if (window.subAppObj.$curAppRouter) {
      window.subAppObj.$curAppRouter.push(routerPushOptions);
    } else {
      if ((window as any).appObj.xmErp) {
        const params = {...queryParams, ...routeParams};
        params['sessionId'] = StorageUtils.getSessionItem("sessionId");
        window.location.href = openUrl(url, params);
        return;
      }
      if (window.appObj && window.appObj.expandCode) {
        window.appObj.$router.push({path: exportUrl, query: queryParams, params: routeParams});
      } else {
        window.appObj.$router.push(routerPushOptions);
      }
    }
  }

  /**
   * 联查上下游数据：应用内多标签打开全流程追溯页
   * @param id 单据 ID（必填）
   * @param docType 单据类型（必填）
   * @param docNo 单据编号（可选，仅用于标签标题）
   */
  openFullProcessTrace(id, docType, docNo) {
    if (id == null || id === '' || docType == null || docType === '') {
      this.showWarningMsg('请传入单据ID和单据类型');
      return;
    }
    const hasDocNo = docNo != null && docNo !== '';
    const pageTitle = hasDocNo ? `联查-${docNo}` : '联查';
    const query = hasDocNo ? {id, docType, docNo} : {id, docType};
    this.routerPath('/fullProcessTrace', query, '', pageTitle);
  }

  /**
   * 按业务单据 id 打开与待办相同的流程处理页（/flowList/simplFlowDeal）
   * 先调 getDealEntryByBusId 换开页参数：仅 canDeal 且 needEdit 时开页；
   * flag 为 false、接口失败或回包非约定格式时返回 skipNeedEdit（调用方走原动作，不提示）。
   * @param busId 业务单据 ID（必填）
   * @param options.tableCode 后端未返回 tableCode 时的兜底
   * @param options.flowTitle 页签标题兜底（后端未返回时用，截前 25 字）
   * @param options.pageFrom 入口来源，缺省 waitDeal
   * @param options.entry 已查到的开页参数，传入则不再请求
   */
  async openSimplFlowDealByBusId(busId, options?) {
    if (busId == null || busId === '') {
      this.showWarningMsg('请传入业务单据ID');
      return 'abort';
    }
    const opt = options && typeof options === 'object' ? options : {};
    let entry = opt.entry;
    if (!entry) {
      try {
        GoingUtils.showLoading?.();
        entry = await getDealEntryByBusId({id: busId});
      } catch (e) {
        console.warn('[openSimplFlowDealByBusId] getDealEntryByBusId failed', e);
        return 'skipNeedEdit';
      } finally {
        try {
          GoingUtils.closeLoading?.();
        } catch (e) { /* noop */ }
      }
    }
    if (!entry) {
      return 'skipNeedEdit';
    }
    const flagOn = (v) => v === true || v === 'true' || v === 1 || v === '1';
    if (!flagOn(entry.canDeal) || !flagOn(entry.needEdit)) {
      return 'skipNeedEdit';
    }
    const tableCode = String(entry.tableCode || opt.tableCode || '').trim();
    const flowId = String(entry.flowId || '').trim();
    const formDataId = String(entry.formDataId || busId).trim();
    if (!flowId || !tableCode || !formDataId) {
      return 'skipNeedEdit';
    }
    const rawTitle = String(entry.flowTitle || opt.flowTitle || '').trim();
    const flowTitle = (rawTitle || '审核').slice(0, 25);
    const pageFrom = String(opt.pageFrom || 'waitDeal').trim() || 'waitDeal';
    this.routerPath('/flowList/simplFlowDeal', {
      recordId: flowId,
      tableCode,
      formDataId,
      pageFrom,
      flowTitle,
    }, '', flowTitle);
    return 'opened';
  }

  /**
   * 按部件 pageCode / moduleCode 打开详情抽屉（加载 xmPageContent）
   * 抽屉 DOM 挂主布局 #PageLayout（不盖侧栏/顶栏）；按 fullPath 隔离可多开；不写入全局状态、不处理单据 ID。
   * @param pageCode 详情页 page code（必填）
   * @param moduleCode 模块 code（必填）
   * @param title 抽屉标题（可选，缺省「单据详情」）
   * @param mainPageCode 关联主界面 page code（可选）；有值时先校验该主界面页面权限
   * @param options 抽屉会话扩展，挂到 payload.opt；使用处读 opt.xxx（如 flowReviewEdit/approveUrl/busId/gridKey/renderExtra）
   */
  async openPageContentDrawer(pageCode, moduleCode, title, mainPageCode?, options?) {
    const page = pageCode != null ? String(pageCode).trim() : '';
    const module = moduleCode != null ? String(moduleCode).trim() : '';
    if (!page || !module) {
      this.showWarningMsg('请传入页面编码和模块编码');
      return;
    }
    const mainPage = mainPageCode != null ? String(mainPageCode).trim() : '';
    if (mainPage) {
      try {
        const allowed = await this.executeQueryApi({
          url: '/api/go-lcc/menuInfoSettingAct/checkPagePermission',
          method: 'POST',
          params: {pageCode: mainPage},
          showLoading: false,
        });
        if (allowed !== true) {
          this.showWarningMsg('您没有访问该主界面的权限');
          return;
        }
      } catch (e) {
        this.showWarningMsg('页面权限校验失败，请稍后重试');
        return;
      }
    }
    const drawerTitle = title != null && String(title).trim() !== '' ? String(title).trim() : '单据详情';
    const opt = options && typeof options === 'object' ? options : {};
    // fullPath 由宿主 PageContentDrawer 用 useRoute() 写入；会话扩展挂在 opt 上，使用处读 opt.xxx
    emitter.emit('openPageContentDrawer', {
      pageCode: page,
      moduleCode: module,
      title: drawerTitle,
      opt,
    });
  }

  /** 关闭当前页签下由 openPageContentDrawer 打开的全部详情抽屉 */
  closePageContentDrawer() {
    emitter.emit('closePageContentDrawer');
  }

  /**
   * 打开变更记录抽屉：任意入口复用（操作栏、详情抽屉右上角等）。
   * 宿主挂在 App.vue，只认 tableCode + bizId，不关心从哪点开。
   * @param tableCode 领域对象编码（必填）
   * @param bizId 业务主键（必填）
   */
  openChangeRecord(tableCode, bizId) {
    const code = tableCode != null ? String(tableCode).trim() : '';
    const id = bizId != null ? String(bizId).trim() : '';
    if (!code || !id) {
      this.showWarningMsg('请传入领域对象编码和业务主键');
      return;
    }
    emitter.emit('openChangeRecord', {tableCode: code, bizId: id});
  }

  /** 关闭当前打开的变更记录抽屉 */
  closeChangeRecord() {
    emitter.emit('closeChangeRecord');
  }

  //全局状态变量切换
  switchVuex(propCode) {
    const {state, elObj} = this.getStateObj(propCode);
    if (elObj) {
      state[propCode] = !state[propCode];
    }
  }

  private getStateObj(propCode) {
    const {state} = this.pageModelsStore;
    const elObj = Object.keys(state).filter((propName) => {
      return propName === propCode;
    })[0];
    return {state, elObj};
  }

//全局状态变量值修改
  changeVuex(propCode, propValue,ctlType='') {
    const {state} = this.pageModelsStore;
    const propCodeList = propCode.split(".");
    //如果是二级对象
    if (propCode.indexOf(".") > 0) {
      const elObj = Object.keys(state).filter((propName) => {
        return propName === propCodeList[0];
      })[0];
      if (elObj) {
        state[propCodeList[0]][propCodeList[1]] = propValue;
      }
    } else {
      if(ctlType==='formObj'){
        if(typeof propValue==='object'){
          Object.keys(propValue).forEach((propName)=>{
            if(propValue[propName]!=null&&propValue[propName]!==""){
              state[propCode][propName]=propValue[propName];
            }
          })
        }
      }else{
        state[propCode] = propValue;
      }
    }
  }

  //发送消息通知pageCode
  sendMsg(msgCode, showMsg = true,busObj={}) {
    const queryCommnad = new QueryCommand({
      url: "/api/pe-message/messageInfo/sendMsgByCode",
      errorFlag: false,
      showTip: false,
      method: "POST"
    });
    queryCommnad.executeQueryPromise({params: {busObj:{...busObj},code: msgCode}}).then((res) => {
      showMsg ? GoingUtils.showMessage("发送成功") : "";
    }, (msg) => {

    });
  }

  /**
   * 执行文件导出操作
   * @param params
   * @param url
   */
  executeFileCommand({params={},url,fileName='文件名称'}){
    const queryCommnad = new QueryCommand({
      errorFlag: false,
      showTip: false});
    if(fileName.split(".").length===1){
      fileName=fileName+".pdf";
    }
    //执行导出操作
    queryCommnad.executeExport(
      url,
      fileName,
      {...params}
    );
  }

  /**
   *  执行操作
   * @param executeObj
   * @param backFun
   */
  executeApi({
               url,
               method,
               params,
               backFun,
               errorFun,
               showLoading = true,
               fileName,
               showErrorFlag = true,
               isFileStream=false,
               nodeProp = {}
             }: IExecuteConfig) {
    if(isFileStream){
      return this.executeFileCommand({params,url,fileName});
    }else{
      const queryCommnad = new QueryCommand({
        url,
        errorFlag: showErrorFlag,
        showTip: showLoading,
        method
      });
      return queryCommnad.executeQueryPromise({params}).then((res) => {
        backFun && backFun(res, nodeProp);

        return res
      }, (msgRes) => {
        const {code, msg} = msgRes;
        if (code && (code + '') !== '200') {
          //如果设置不需要显示错误 则跳过
          if (showErrorFlag === false) {
            return;
          }
          errorFun && errorFun();
          // showErrorMessage(code, msg)
        }
      });
    }
  }


  executeAsyncApi({url, method, params}: IExecuteConfig) {
    if ((method + '').toLowerCase() === 'get') {
      return executeGetAsyncApi(url, params);
    } else {
      return executePostAsyncApi(url, params);
    }
  }

  /**
   * 校验子表格
   * @param formKey
   * @param recordId
   * @param okFun
   * @param errorFun
   */
  validateGrid(formKey, recordId, okFun, errorFun) {
    if (formKey.indexOf("tableKey_") >= 0) {
      const gridKey = formKey.split("tableKey_")[1]
      emitter.emit(GoingUtils.getEventCtlKey(gridKey) + '_validateCurRowRecord', {recordId, okFun, errorFun});
    }
  }

  /**
   * 校验数据表格（xmRelQuery / xmSubTable 全量行）
   * @param gridKey 表格组件 key
   * @param okFun 校验通过回调
   * @param errorFun 校验失败回调
   */
  validateTable(gridKey, okFun, errorFun?: any, onlySelected?: any) {
    const modelObj = this.pageModelsStore?.state;
    const subTableList = [buildSubObjByGridKey(gridKey)];
    const only = GoingNewUtils.parseBoolean(onlySelected);
    const valid = getAllSubTableFlag(subTableList, modelObj, {errorPrefix: '数据表格', onlySelected: only});
    nextTick(() => {
      if (only) {
        flushSubTableValidateStyle(subTableList, {recordIds: getSelectedMarkRecordIds(gridKey)});
      } else {
        flushSubTableValidateStyle(subTableList);
      }
      if (valid) {
        okFun && okFun();
      } else {
        errorFun && errorFun();
      }
    });
  }

  /**
   * 校验子表单
   */
  async validateSubPageForm(okFun, errorFun,pageContentElKey) {
    executeValidateForm(okFun, errorFun,pageContentElKey)
  }
  /**
   * 变量校验
   */
  validateVuexObj({validateType,validateOrginVal,validateNumberType,validateTargetValue}, okFun, errorFun?: any) {
    //校验数值
    if(validateType==='validateRequired'){
      if(!(validateOrginVal===null||validateOrginVal===undefined||validateOrginVal==='')){
        okFun && okFun();
        return 'ok'
      }
    }else if(validateType==='validateNumber'){
      if(validateNumberType==='>'&&parseFloat(validateOrginVal)>parseFloat(validateTargetValue)){
        okFun && okFun();
        return 'ok'
      }
      if(validateNumberType==='>='&&parseFloat(validateOrginVal)>=parseFloat(validateTargetValue)){
        okFun && okFun();
        return 'ok'
      }
      if(validateNumberType==='='&&parseFloat(validateOrginVal)==parseFloat(validateTargetValue)){
        okFun && okFun();
        return 'ok'
      }
      if(validateNumberType==='<'&&parseFloat(validateOrginVal)<parseFloat(validateTargetValue)){
        okFun && okFun();
        return 'ok'
      }
      if(validateNumberType==='<='&&parseFloat(validateOrginVal)<=parseFloat(validateTargetValue)){
        okFun && okFun();
        return 'ok'
      }
    }else if(validateType==='validateEqual'){
      if((validateOrginVal+'')===(validateTargetValue+'')){
        okFun && okFun();
        return 'ok'
      }
    }else if(validateType==='validateNotEqual'){
      if((validateOrginVal+'')!==(validateTargetValue+'')){
        okFun && okFun();
        return 'ok'
      }
    }
    errorFun && errorFun();
    return 'error'
  }

  /**
   * 表单校验
   */
  async validateForm(formKey, okFun, errorFun?: any) {
    if ((formKey+'').indexOf("subPageForm")===0) {
      this.validateSubPageForm(okFun, errorFun,formKey);
      return;
    }
    let flag = false;
    let validateErrorEl: any = null;
    await emitter.emit(formKey + 'validateFormXm', {
      backFun: () => {
        console.log("----校验成功---");
        flag = true;
        okFun && okFun();
      }, errorFun: () => {
        flag = false;
        errorFun && errorFun();
        console.error("----校验失败---");
      }
    });
    nextTick(() => {
      //如果存在错误消息
      validateErrorEl = document.querySelector(".validateError");
      if (validateErrorEl) {
        return;
      }
    })
  }

  /**
   * 获取表格选择记录id集合
   * @param gridKey
   */
  getGridSelRecord(gridKey, returnOneRecord = false) {
    const gridTableStore: any = useGridTableStore();
    const selRecords = gridTableStore.getRecordObjs(gridKey);
    if (selRecords && selRecords.length > 0) {
      if (returnOneRecord) {
        return selRecords[0];
      }
      return selRecords;
    } else {
      if (returnOneRecord) {
        return null
      } else {
        return [];
      }
    }
  }

  /**
   * 显示附件窗口
   * @param gridKey
   * @param returnOneRecord
   */
  showFileWin(gridKey, recordId) {
    eventBus.emit(GoingUtils.getEventCtlKey(gridKey) + '_showFileWin', {recordId});
  }


  /**
   * 获取表格选择记录id集合
   * @param gridKey
   */
  getGridSelRecordIds(gridKey, returnOneRecord = false, strFlag = false, joinChar) {
    const gridTableStore: any = useGridTableStore();
    const selRecords = gridTableStore.getGridSels(gridKey);
    if (selRecords && selRecords.length > 0) {
      if (returnOneRecord) {
        return selRecords[0];
      }
      //如果存在 joinChar 则返回字符串 否则返回对象数组
      if (strFlag && joinChar) {
        return selRecords.join(joinChar || ";");
      }
      return selRecords;
    }
    return [];
  }

  /**
   * 改变行高
   * @param gridKey
   * @param params
   */
  changeGridRowHeight(gridKey, inParams) {
    const gridTableStore: any = useGridTableStore();
    gridTableStore.changeGridRowHeight(gridKey, inParams);
  }

  /**
   * 表格刷新能力
   * @param gridKey
   *  viewModel.flushGrid('Newaimgfbkfsscpdkssclecssij',{},false,true,'and',true);;
   */
  flushGrid(gridKey, paramsJson, initCurrent = false, extendParams = false, paramsRel = '', clearSelRecord = false, userUrl = '') {
    const params = cleanEmptyValues(paramsJson);
    if ((userUrl + '').indexOf("#{vuex.") >= 0) {
      const {state} = this.pageModelsStore;
      const ary = (userUrl + '').split("#{vuex.");
      const paramsName = ary[1].split("}")[0];
      userUrl = (userUrl + '').replace("#{vuex." + paramsName + "}", state[paramsName]);
    }
    try{
      if (clearSelRecord) {
        executeEngineEvent(gridKey, 'clearGridSelList')
      }
    }catch (e){}
    const gridTableStore: any = useGridTableStore();
    //如果是多个组件同时刷新 则调多个id 分隔串起来
    if (gridKey.indexOf(";") >= 0) {
      gridKey.split(";").forEach((ctlKey) => {
        gridTableStore.flushGrid(gridKey, params, initCurrent, extendParams, paramsRel, clearSelRecord, userUrl);
      })
    } else {
      gridTableStore.flushGrid(gridKey, params, initCurrent, extendParams, paramsRel, clearSelRecord, userUrl);
    }
  }

  /**
   * 清空数据
   */
  clearCtlDate(gridKey) {
    const gridTableStore: any = useGridTableStore();
    //如果是多个组件同时刷新 则调多个id 分隔串起来
    if (gridKey.indexOf(";") >= 0) {
      gridKey.split(";").forEach((ctlKey) => {
        gridTableStore.clearCtlDate(gridKey);
      })
    } else {
      gridTableStore.clearCtlDate(gridKey);
    }
  }

  /**
   * 获取表单对象值
   */
  getFormVuexVal(selKey) {
    const {state} = this.pageModelsStore;
    console.error(state[selKey],"-------getFormVuexVal")
    if (state[selKey] && typeof state[selKey] === 'object') {
      return deepClone(state[selKey])
    }
    return state[selKey];
  }


  /**
   * 重置表单对象值
   * @param selKey
   */
  formResetFields(selKey) {
    const gridTableStore: any = useGridTableStore();
    const tableObj = gridTableStore.getGridObjByKey(selKey);
    const {state} = this.pageModelsStore;
    state[selKey] = {};
    if (tableObj) {
      gridTableStore.formResetFields(selKey);
    }
  }

  /**
   * 初始化表单值
   * @param selKey
   * @param obj
   */
  initFormValues(selKey, obj) {
    const {state} = this.pageModelsStore;
    state[selKey] = deepClone(obj);
  }

  /**
   * 执行查询Api
   * @param url
   * @param backFun
   * @param params
   */
  async executeQueryApi({url, method, params}) {
    let queryCommand = new QueryCommand({
      url: url,
      method: method || 'POST'
    });
    const {delRelParams} = params;
    if (delRelParams && typeof delRelParams === 'object') {
      if (Object.keys(delRelParams).length === 0) {
        delete params['delRelParams'];
      }
    }
    //执行查询操作
    const res = await queryCommand.executeQueryPromise({params});
    return res;
  }


  /**
   * 删除领域操作
   * @param url
   * @param ids
   */
  async delDomain(url, method = 'POST', ids, paramsName = 'ids', delRelParams = {}) {
    if (ids) {
      if (delRelParams && !delRelParams.relDomain) {
        delRelParams = {};
      }
      if (typeof (ids) === 'object') {
        return await this.executeQueryApi({url: url.trim(), params: {...ids, delRelParams}, method: method});
      } else {
        const parasObj = {};
        parasObj[paramsName] = ids;
        return await this.executeQueryApi({url: url.trim(), params: {...parasObj, delRelParams}, method: method});
      }
    } else {
      GoingUtils.showErrorMessage("删除id不存在，请联系管理员确认！")
    }
  }

  /**
   * 根据多参数进行删除
   * @param url
   * @param method
   * @param ids
   * @param paramsName
   */
  async delDomainByParams(url, method = 'POST', params) {
    const res = await this.executeQueryApi({url: url.trim(), params: {...params}, method: method});
    return res;
  }

  /**
   * 修改领域操作
   * @param url
   * @param method
   * @param modObj
   */
  async modDomain(url, method = 'POST', modObj) {
    return await this.executeQueryApi({url: url.trim(), params: {...modObj}, method: method});
  }

  /**
   * 时长计算
   * @param paramsOne
   * @param paramsTwo
   */
  hourDiff(paramsOne, paramsTwo) {
    const startTime = dayjs(paramsOne);
    const endTime = dayjs(paramsTwo);
    return endTime.diff(startTime, 'hours');
  }

  /**
   * 日期差
   * @param paramsOne
   * @param paramsTwo
   */
  dayDiff(paramsOne, paramsTwo) {
    const startTime = dayjs(paramsOne);
    const endTime = dayjs(paramsTwo);
    return endTime.diff(startTime, 'day');
  }

  /**
   * 数量差
   * @param paramsOne
   * @param paramsTwo
   */
  numberDiff(paramsOne, paramsTwo) {
    const startTime = parseFloat(paramsOne);
    const endTime = parseFloat(paramsTwo);
    return endTime - startTime;
  }

  /**
   * 查询领域实体操作
   * @param url
   * @param id
   */
  async queryDomain(url, method = 'GET', id) {
    let params = {};
    if (id != null) {
      params = {...id};
    }
    return await this.executeQueryApi({url: url.trim(), params, method: method});
  }

  /**
   * '/api/go-lcc/execute/saveByTableCode/TB_000000_FNEMCOIISSJK'
   * 新增领域操作
   */
  async addDomainRecord(url, method = 'POST', addObj) {
    return await this.executeQueryApi({url: url.trim(), params: {...addObj}, method: method});
  }

  /**
   * 弹出框输入框 回调函数
   * @param list
   */
  setWinInputBackList(backObj) {
    eventBus.emit(window.FunctionEngine.inputPropsKey + 'setBackRecords', backObj);
  }
}

export class FunctionEngineClass {

}

window.FunctionEngine = new FunctionEngineClass();
if (window.FunctionEngine['routerBack']) {
  window.FunctionEngine['routerBack'] = null;
}
window.FunctionEngine['routerBack'] = function () {
  if (window.appObj && window.appObj.$router) {
    window.appObj.$router.back(-1);
  }
}
